declare global {
  interface Window {
    newrelic?: {
      addPageAction(name: string, attributes?: Record<string, any>): void;
    };
    dataLayer?: any[];
  }
}

export default function () {
  if (process.env.GOOGLE_TAG_MANAGER_ID_EXTRA) {
    window.dataLayer = window.dataLayer || [];

    const originalPush = window.dataLayer.push;

    // Wrap the dataLayer.push method to intercept events
    window.dataLayer.push = function (...args) {
      for (const eventData of args) {
        if (eventData?.event === 'gtm.dom') {
          window.newrelic?.addPageAction('gtmDomEventTriggered', {
            timestamp: Date.now()
          });
        }
      }

      return originalPush.apply(window.dataLayer, args);
    };

    // Add additional container script tag to head
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://www.googletagmanager.com/gtm.js?id=' + process.env.GOOGLE_TAG_MANAGER_ID_EXTRA;

    // handler to detect when the GTM script has loaded
    script.onload = () => {
      window.newrelic?.addPageAction?.('gtmScriptLoaded', {
        timestamp: Date.now(),
        src: script.src
      });
    };

    document.head.appendChild(script);

    const existingGtmScript = document.querySelector(
      `script[src*="https://www.googletagmanager.com/gtm.js?id=${process.env.GOOGLE_TAG_MANAGER_ID_EXTRA}"]`
    );
    // additional duplication checking to safely add the script (DPTQ-6743)
    if (existingGtmScript) {
      existingGtmScript.innerHTML = hardcodedGtmScript();
    } else {
      // add gtm initialiser
      const scriptWindow = document.createElement('script');
      scriptWindow.async = true;
      scriptWindow.innerHTML = hardcodedGtmScript();
      document.head.appendChild(scriptWindow);
    }

    // Add additional container <noscript> tag to body
    const noscript = document.createElement('div');
    noscript.dataset.nHead = 'ssr';
    noscript.dataset.pbody = 'true';
    noscript.innerHTML =
      '<noscript><iframe src="https://www.googletagmanager.com/ns.html?id=' +
      process.env.GOOGLE_TAG_MANAGER_ID_EXTRA +
      '" height="0" width="0" style="display:none;visibility:hidden" title="gtm"></iframe></noscript>';
    document.body.prepend(noscript);
  }
}

const hardcodedGtmScript = () => {
  // eslint-disable-next-line max-len, prettier/prettier, quotes
  const partialScript = "(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start': new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0], j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer','"
  const completedSript = partialScript + process.env.GOOGLE_TAG_MANAGER_ID_EXTRA.toString() + `')`;
  return completedSript.toString();
};
